import type { ApolloCache } from '@apollo/client';

export const evictListingWithoutAccess = (
  cache: ApolloCache,
  listing: { id: string; property?: unknown } | null | undefined,
) => {
  if (listing != null && listing.property == null) {
    cache.evict({ id: `lots:${listing.id}` });
  }
};
